<template>
     <v-card flat>
        <v-card-title primary class="title" style="font-size: 14px; padding-top: 0px; padding-bottom: 0px">
            <template v-if="isDeliveryAddress">Delivery address</template>
            <template v-else>Address</template>
        </v-card-title>
        <v-card-text style="font-size: 12px">
            <div v-if="customer !== null">
                {{`${customer.Firma}`}}<br>
                {{`${customer.Vorname} ${customer.Nachname}`}}<br>
                {{`${customer.Adresse1}`}}<br>
                {{`${customer.Adresse2}`}}<br>
                {{`${customer.Plz} ${customer.Stadt}`}}<br>
                {{`${customer.Land}`}}<br><br>
                {{`${customer.Email}`}}<br>
                {{`${customer.Tel}`}}<br>

                <template v-if="customer.Uid">UID: {{`${customer.Uid}`}}</template> <br>
                <template v-if="!isDeliveryAddress">{{ order.wo_po_number }}</template>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapGetters } from "vuex"

export default {
    props: {
        customerId: {
            type: Number,
            //  required: true
        },
        isDeliveryAddress: {
            type: Boolean,
            default: false
        },
        order: {
            type: Object
        }
    },
    components: {},
    data() {
        return {
            customer: null
        }
    },
    computed: {
        ...mapGetters(["orders"])
    },
    methods: {
        close () {
            this.$emit('close')
        }
    },
    watch: {
        order: function (value) {
           
        
        }
    },
    created() {

    },
    mounted () {
        if (this.customerId !== 0) {
            this.$store.dispatch('getOrderAddress', this.customerId)
                .then(customer => this.customer = customer)
        }
    }
}
</script>
